import React, { ReactNode, FC } from "react";
import { ToastContainer } from "react-toastify";

import Header from "../ui/header/header";
import Footer from "../ui/footer/footer";

import styles from "./index.module.css";

type LayoutProps = {
  children?: ReactNode;
};
const Layout: FC<LayoutProps> = (props) => {
  const { children } = props;
  return (
    <>
      <Header />
      <div className={styles.container}>{children}</div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default Layout;
